import * as yup from 'yup';
import texts from './hebrew-only.texts.json';

declare module 'yup' {
  interface StringSchema {
    heb(): StringSchema;
  }
}
export const HEBREW_REGEX = /^([\u0590-\u05FF.,"']+\s?)+$/;

export const defineHebrewOnlyValidator = () => {
  yup.addMethod(yup.string, 'heb', () => {
    return yup.string().matches(HEBREW_REGEX, { message: texts.invalidError });
  });
};
